namespace Gamification.Gamification {
    export interface ProdottiLivelliForm {
        IdentifierLivello: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Ordine: Serenity.IntegerEditor;
        ValoreMinimo: Serenity.IntegerEditor;
        ValoreMassimo: Serenity.IntegerEditor;
    }

    export class ProdottiLivelliForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiLivelli';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiLivelliForm.init)  {
                ProdottiLivelliForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(ProdottiLivelliForm, [
                    'IdentifierLivello', w0,
                    'Nome', w0,
                    'Ordine', w1,
                    'ValoreMinimo', w1,
                    'ValoreMassimo', w1
                ]);
            }
        }
    }
}
